import React from 'react';
export function Process() {
  const steps = [{
    num: '01',
    title: 'Consultation',
    desc: 'Initial strategy session to understand your career trajectory, board aspirations, and unique value proposition.'
  }, {
    num: '02',
    title: 'Career Discovery',
    desc: 'Deep-dive intake process to extract key achievements, leadership philosophy, and governance experience.'
  }, {
    num: '03',
    title: 'Executive Branding Strategy',
    desc: 'Developing a cohesive narrative that aligns your background with target board or C-suite opportunities.'
  }, {
    num: '04',
    title: 'Resume Development',
    desc: 'Crafting a high-impact, ATS-optimized, and visually premium executive resume.'
  }, {
    num: '05',
    title: 'LinkedIn Optimization',
    desc: 'Aligning your digital presence with your new executive brand to attract search firms.'
  }, {
    num: '06',
    title: 'Final Delivery',
    desc: 'Review, refinement, and delivery of your complete executive portfolio.'
  }];
  return <section id="process" className="py-24 bg-white" data-id="element-270">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <div className="text-center mb-16" data-id="element-272">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-273">
            Our Methodology
          </span>
          <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-navy-900 mb-6" data-id="element-274">
            The Executive Branding Process
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-275">
            A structured, high-touch approach designed to extract and articulate
            your highest strategic value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-id="element-276">
          {steps.map((step, index) => <div key={index} className="relative pl-16" data-id="element-277">
              <div className="absolute left-0 top-0 text-4xl font-serif-display font-bold text-navy-100 leading-none" data-id="element-278">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3 relative z-10 mt-1" data-id="element-279">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-280">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}